export default __webpack_public_path__ + "static/media/footprint-info-02.1a9a7390.svg";